export const FEATURES_DATA = [
  {
    title: "Virtual Classes",
    desc: "Seed to Tree Online Academy offers flexible virtual classes, personalized learning, expert instructors, and a wide course selection for transformative education.",
    icon: "ri-draft-line",
  },

  {
    title: "Expert Support",
    desc: "Seed to Tree offers expert support for students and educators, ensuring personalized guidance and success in your educational journey. Join us today!",
    icon: "ri-discuss-line",
  },

  {
    title: "Certifications",
    desc: "Boost your career with Seed to Tree Online Academy's industry-recognized certifications for personal growth and improved employability. Join us today!",
    icon: "ri-contacts-book-line",
  },
];